import { useMutation } from '@tanstack/react-query';

import { getZendeskSsoUrl } from 'src/features/support-hub/api/requests';

import { ZendeskSsoResponse } from '../api/types';

export const useGetZendeskSsoUrl = () =>
    useMutation<ZendeskSsoResponse>({
        mutationKey: ['getZendeskSsoUrl'],
        mutationFn: getZendeskSsoUrl,
        onSuccess: (data) => {
            window.location.assign(data.url);
        },
    });
